import store from '@/store'

export default [
  {
    path: '/purchase-orders',
    name: 'purchase-order',
    meta: { requiresAuth: true },
    component: () => import('@/pages/purchase-order/index.vue'),
    beforeEnter: async (to, from, next) => {
      next()
    }
  },
  {
    path: '/purchase-orders/create',
    name: 'purchase-order-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/purchase-order/create.vue')
  },
  {
    path: '/purchase-orders/:id',
    name: 'purchase-order-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/purchase-order/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('purchaseOrder/find', to.params.id)
      next()
    }
  }
]
